import { CountryCode } from './type';
import type { Country } from './type';

export const newZealand: Country = {
    name: 'New Zealand',
    nameFull: 'New Zealand',
    code: CountryCode.NZ,
    displayCode: CountryCode.NZ,
    combinedDisplayCode: CountryCode.NZ,
    makeMethod: 'makeNewZealand',
    theme: false,
    currency: '$',
    currencyName: 'NZD',
    currencyWithCountry: 'NZ$',
    maxImageSize: 21000000, // 21MB
    imageOptions: {
        maxSize: 21000000,
        fileType: ['.jpg','.jpeg','.gif']
    },
    maxGoodNumberPerClass: 1000,
    paymentMethodsImageName: 'payment-options-nz.png',
    stripeKey: import.meta.env.VITE_STRIP_PUBLIC_KEY_NZ,
    autoSelectedInForm: true,
};
